import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, ViewEncapsulation, Component, NgModule } from '@angular/core';
import { E11TemplateMap, E11UtilModule } from '@engineering11/ui-lib/e11-ui-utils';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { E11ButtonModule } from '@engineering11/ui-lib/e11-button';
import { E11DirectivesModule } from '@engineering11/ui-lib/e11-directives';

class E11NavExpanderComponent extends E11TemplateMap {
    constructor() {
        super();
        this.selected = false; // An override to let you externally open a nav-expander
        this.isOpen = false; // If we want multiple open at once - only one can be "selected" at a time
        this.expanderClick = new EventEmitter();
    }
    ngOnInit() { }
    expanderClicked() {
        if (!this.selected) {
            this.isOpen = !this.isOpen;
        }
        else {
            this.isOpen = false;
            this.selected = false;
        }
        this.expanderClick.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11NavExpanderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.13", type: E11NavExpanderComponent, selector: "e11-nav-expander", inputs: { selected: "selected", expanderContainerClassOverrides: "expanderContainerClassOverrides", expanderContainerNgClass: "expanderContainerNgClass" }, outputs: { expanderClick: "expanderClick" }, usesInheritance: true, ngImport: i0, template: `
    <div
      class="e11-nav-expander-container e11-flex e11-items-center e11-h-10 e11-px-2 e11-cursor-pointer e11-mb-[2px] {{
        expanderContainerClassOverrides
      }}"
      [ngClass]="expanderContainerNgClass"
      (click)="expanderClicked()"
    >
      <div class="e11-grow">
        <ng-container *ngTemplateOutlet="e11TemplateMap['expander']"></ng-container>
      </div>
      <div class="e11-flex e11-items-center">
        <span class="material-icons-outlined e11-nav-expander-indicator" [ngClass]="{ 'e11-nav-expander-indicator-selected': isOpen || selected }">
          expand_more
        </span>
      </div>
    </div>

    <div class="e11-nav-expander" [ngClass]="{ 'e11-nav-expander-active': isOpen || selected }">
      <ng-container *ngTemplateOutlet="e11TemplateMap['content']"></ng-container>
    </div>
  `, isInline: true, styles: [".e11-nav-expander{overflow:hidden;max-height:0;opacity:0;transition:all .2s ease-in-out 0s}.e11-nav-expander.e11-nav-expander-active{max-height:500px;overflow-y:auto;opacity:1;transition:all .4s ease-in-out 0s}.e11-nav-expander-indicator{transform:rotate(0);transition:all .1s ease-in-out 0s}.e11-nav-expander-indicator.e11-nav-expander-indicator-selected{transition:all .2s ease-in-out 0s;transform:rotate(180deg)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11NavExpanderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'e11-nav-expander', template: `
    <div
      class="e11-nav-expander-container e11-flex e11-items-center e11-h-10 e11-px-2 e11-cursor-pointer e11-mb-[2px] {{
        expanderContainerClassOverrides
      }}"
      [ngClass]="expanderContainerNgClass"
      (click)="expanderClicked()"
    >
      <div class="e11-grow">
        <ng-container *ngTemplateOutlet="e11TemplateMap['expander']"></ng-container>
      </div>
      <div class="e11-flex e11-items-center">
        <span class="material-icons-outlined e11-nav-expander-indicator" [ngClass]="{ 'e11-nav-expander-indicator-selected': isOpen || selected }">
          expand_more
        </span>
      </div>
    </div>

    <div class="e11-nav-expander" [ngClass]="{ 'e11-nav-expander-active': isOpen || selected }">
      <ng-container *ngTemplateOutlet="e11TemplateMap['content']"></ng-container>
    </div>
  `, encapsulation: ViewEncapsulation.None, styles: [".e11-nav-expander{overflow:hidden;max-height:0;opacity:0;transition:all .2s ease-in-out 0s}.e11-nav-expander.e11-nav-expander-active{max-height:500px;overflow-y:auto;opacity:1;transition:all .4s ease-in-out 0s}.e11-nav-expander-indicator{transform:rotate(0);transition:all .1s ease-in-out 0s}.e11-nav-expander-indicator.e11-nav-expander-indicator-selected{transition:all .2s ease-in-out 0s;transform:rotate(180deg)}\n"] }]
        }], ctorParameters: () => [], propDecorators: { selected: [{
                type: Input
            }], expanderContainerClassOverrides: [{
                type: Input
            }], expanderContainerNgClass: [{
                type: Input
            }], expanderClick: [{
                type: Output
            }] } });

const DECLARE_EXPORT_COMPONENTS = [E11NavExpanderComponent];
class E11NavExpanderModule {
    static forRoot() {
        return {
            ngModule: E11NavExpanderModule,
            providers: [], // Be extremely careful about declaring services in providers arrays - it can prevent them from being singletons
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11NavExpanderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: E11NavExpanderModule, declarations: [E11NavExpanderComponent], imports: [CommonModule, E11UtilModule, E11DirectivesModule, E11ButtonModule], exports: [E11UtilModule, E11DirectivesModule, E11NavExpanderComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11NavExpanderModule, imports: [CommonModule, E11UtilModule, E11DirectivesModule, E11ButtonModule, E11UtilModule, E11DirectivesModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: E11NavExpanderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [...DECLARE_EXPORT_COMPONENTS],
                    imports: [CommonModule, E11UtilModule, E11DirectivesModule, E11ButtonModule],
                    exports: [E11UtilModule, E11DirectivesModule, ...DECLARE_EXPORT_COMPONENTS],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DECLARE_EXPORT_COMPONENTS, E11NavExpanderComponent, E11NavExpanderModule };
